export const poolparty = {
  name: 'Pool Party',
  color: [0.3607843137254902, 0.7725490196078432, 0.9372549019607843, 1],
  bg: [0.20392156862745098, 0.30196078431372547, 0.5647058823529412, 1],
  grid1: [0.9764705882352941, 0.6509803921568628, 0.011764705882352941, 1],
  grid2: [0.9058823529411765, 0.3333333333333333, 0.17254901960784313, 1],
}
